import React, { useState } from "react";
import "../components/EtpBan.css";
import ETPVIDEO from "../images/videos/VIDEOS/VID2.mp4";

export default function EtpBan() {

  const phone = "919597839564";

  const [showForm, setShowForm] = useState(false);
  const [org, setOrg] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState("");
  const [etpType, setEtpType] = useState("");   // ✅ SINGLE ETP TYPE
  const [details, setDetails] = useState("");

  const etpOptions = [
    "Chemical ETP",
    "Biological ETP",
    "Physico-Chemical ETP",
    "Zero Liquid Discharge (ZLD)",
    "Package / Compact ETP"
  ];

  // ✅ single-select checkbox logic
  const handleCheckbox = (value) => {
    setEtpType(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!org || !mobile || !etpType) {
      alert("Please fill required fields and select one ETP type");
      return;
    }

    const message = encodeURIComponent(
      `Hello RAD ENVIRONEX 👋\n\n` +
      `ETP Installation Enquiry\n\n` +
      `Organization / Industry: ${org}\n` +
      `Address: ${address}\n` +
      `Phone: ${mobile}\n\n` +
      `ETP Type Required:\n` +
      `• ${etpType}\n\n` +
      `Effluent / Service Details:\n${details}`
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <video
          className="hero-video"
          src={ETPVIDEO}
          autoPlay
          loop
          muted
          playsInline
        />

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="title-box animate-glow">
            <h1>Effluent Treatment Plant</h1>
            <p>Industrial Wastewater Treatment Solutions</p>

            <button className="quote-btn" onClick={() => setShowForm(true)}>
              Get Quote
            </button>
          </div>
        </div>
      </section>

      {/* ETP FORM MODAL */}
      {showForm && (
        <div className="quote-modal">
          <div className="quote-form-box">
            <h2>ETP Installation Enquiry</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Organization / Industry Name *"
                value={org}
                onChange={(e) => setOrg(e.target.value)}
              />

              <input
                type="text"
                placeholder="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />

              <input
                type="tel"
                placeholder="Phone Number *"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />

              {/* ETP TYPE */}
              <div className="checkbox-group">
                <p>ETP Type Required *</p>

                <div className="checkbox-grid">
                  {etpOptions.map((item, index) => (
                    <label key={index} className="checkbox-item">
                      <input
                        type="checkbox"
                        checked={etpType === item}      // ✅ KEY FIX
                        onChange={() => handleCheckbox(item)}
                      />
                      <span>{item}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* DETAILS */}
              <textarea
                placeholder="Effluent Characteristics / Service Requirement"
                value={details}
                onChange={(e) => setDetails(e.target.value)}
              />

              <div className="form-actions">
                <button type="submit">Send via WhatsApp</button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
